import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * New Bidding Console experiment
 *
 * @returns boolean indicating if user is in treatment variant (new bidding console)
 */
export const useNewBiddingConsoleExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.NewBiddingConsole, AmplitudeVariants.NewBiddingConsole.Treatment);
